
import RemoteTeacher from "../models/RemoteTeacher"
import { settlements } from "../views/Administrator/PaymentMails"
import { DateInterval } from "../views/components/Utils/DatePickerButton"
import sendMails from "./sendPaymentMails"

export default (dateInterval: DateInterval, teachers: RemoteTeacher[]) =>
 sendMails({ type: 'SEND_SETTLEMENTS', route: 'settlements', pluralMailConcept: settlements, dateInterval, teachers })